import { render, staticRenderFns } from "./ResourceState.vue?vue&type=template&id=c800804c&scoped=true&"
import script from "./ResourceState.vue?vue&type=script&lang=js&"
export * from "./ResourceState.vue?vue&type=script&lang=js&"
import style0 from "./ResourceState.vue?vue&type=style&index=0&id=c800804c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c800804c",
  null
  
)

export default component.exports